import { render, staticRenderFns } from "./ConsultarExamenes.vue?vue&type=template&id=7fddfb40"
import script from "./ConsultarExamenes.vue?vue&type=script&lang=js"
export * from "./ConsultarExamenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports